import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as faHeartSolid } from '@fortawesome/pro-solid-svg-icons';
import {
  faHeart,
  faTrash,
  faBan,
  faLink,
  faCheck,
} from '@fortawesome/pro-regular-svg-icons';

import Authorize from '../../../Authorize';
import { PHOTOS_WRITE } from '../../../Authorize/permissions/resources';
import { banHandler, deleteHandler } from '../../actionHelper';
import { toggleFavorite } from '../../actions';
import { DELETE_PHOTO, BAN_PHOTO_USER } from '../../permissions';
import { setLargeImageUrl, unsetFullscreenSnapshot } from '../actions';
import { displayErrorModal } from '../../../../helpers/swal';

import style from './style.module.scss';

const MobileLightboxControls = ({
  snapshot,
  toggleFavoriteAction,
  unsetFullscreenSnapshotAction,
  setLargeImageUrlAction,
}) => {
  const [linkCopied, setLinkCopied] = useState(false);

  if (!snapshot) return null;

  const {
    _id: snapshotId,
    favorite,
    sharedURI,
    hidden,
    userId,
    rawURI,
    rawEnhancedURI,
  } = snapshot;

  const banBtnHandler = (userBan) => (evt) => {
    evt.stopPropagation();
    if (userBan) {
      banHandler(!hidden, snapshotId, userId);
    } else {
      banHandler(!hidden, snapshotId);
    }
  };

  const deleteBtnHandler = async () => {
    const isDeleted = await deleteHandler(snapshotId, sharedURI);
    if (isDeleted) {
      unsetFullscreenSnapshotAction();
      setLargeImageUrlAction(null);
    }
  };

  const copyLinkHandler = async () => {
    const link = rawEnhancedURI || rawURI || '';
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 1500);
    } catch (err) {
      console.error(err);
      displayErrorModal();
    }
  };

  return (
    <div className={style.controlsBar}>
      <button
        type="button"
        onClick={() => toggleFavoriteAction(snapshot)}
        className={style.controlBtn}
        aria-label={favorite ? 'Unfavorite' : 'Favorite'}
      >
        <FontAwesomeIcon icon={favorite ? faHeartSolid : faHeart} />
      </button>

      <Authorize permissions={BAN_PHOTO_USER}>
        <Dropdown alignRight className={style.dropdownWrap}>
          <Dropdown.Toggle variant="link" className={style.controlBtn} id="mobile-lightbox-ban">
            <FontAwesomeIcon icon={faBan} />
          </Dropdown.Toggle>
          <Dropdown.Menu className="mobile-lightbox-ban-menu">
            <Dropdown.Item onClick={banBtnHandler(false)}>
              {hidden ? 'Unban' : 'Ban'}
              {' '}
              Photo
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={banBtnHandler(true)}>
              {hidden ? 'Unban' : 'Ban'}
              {' '}
              User
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Authorize>

      <Authorize or permissions={[PHOTOS_WRITE, DELETE_PHOTO]}>
        <button
          type="button"
          onClick={deleteBtnHandler}
          className={style.controlBtn}
          aria-label="Delete"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </Authorize>

      <button
        type="button"
        onClick={copyLinkHandler}
        className={style.controlBtn}
        aria-label={linkCopied ? 'Copied' : 'Copy link'}
      >
        <FontAwesomeIcon icon={linkCopied ? faCheck : faLink} />
      </button>
    </div>
  );
};

export default connect(
  ({
    lightbox: {
      snapshot: {
        data: snapshot,
      },
    },
  }) => ({ snapshot }),
  {
    toggleFavoriteAction: toggleFavorite,
    unsetFullscreenSnapshotAction: unsetFullscreenSnapshot,
    setLargeImageUrlAction: setLargeImageUrl,
  },
)(MobileLightboxControls);
